export enum FilmOffice_status {
  Enabled = 'enabled',
  Disabled = 'disabled'
}

export const FilmOffice_status_Dictionary = {
  [FilmOffice_status.Enabled]: 'Ενεργό',
  [FilmOffice_status.Disabled]: 'Ανενεργό'
};
